import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import { FaCartArrowDown } from "react-icons/fa";
import { ThreeDots } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import { returnItem } from "../../assets/svgIcons";
import UseCartFavourite from "../../hooks/useCartFavourite";
import UseGeneral from "../../hooks/useGeneral";
import { fetchCartData } from "../../store/cartReducer";
import PopUp from "../popup";
import ProductInCartMangeButton from "../productInCartMangeButton/productInCartMangeButton";
import {
  addItem,
  addWithWeight,
} from "../../store/offlineCartReducer/OfflineCartReducer";
import { MdOutlineChangeCircle } from "react-icons/md";
import Skeleton from "react-loading-skeleton";
import { IoMdClose } from "react-icons/io";

const ProductDetailsTexts = ({
  eqData,
  addToCartWithOptions,
  getCartDetails,
  item,
  choosedOption,
  setChoosedOptions,
  getItmData,
}) => {
  const offlineCart = useSelector((state) => state.offlineCart);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [editLoading, setEditLoading] = useState(false);
  const [showChangeWeight, setShowChangeWeight] = useState(false);
  const { isItemInCart, addItemToCart, update, cart } = UseCartFavourite();
  const { language } = UseGeneral();
  const [addLoading, setAddLoading] = useState(false);
  const [showRetPop, setShowRetPop] = useState(false);
  const [showEditWeight, setShowEditWeight] = useState(false);
  const [weights, setWeights] = useState([]);
  // const [openQ]
  const [openQuantity, setOpenQuantity] = useState(false);
  // const [return]
  const [showOpenWeight, setShowOpenWeight] = useState(false);
  const [quantity, setQuantity] = useState("");
  const [delLoading, setDelLoading] = useState(false);
  const [returnpolicies, setReturnpolicies] = useState([]);
  const [totalPrice, setTotalPrice] = useState(item?.price);
  // const [itemWithWeight,setItemWithWeight]=useState({});
  const [weight, setWeight] = useState({});
  const [open, setOpen] = useState(false);
  const [weightLoading, setWeightLoading] = useState(false);
  // toast.success('reeef')
  const addToCart = () => {
    setAddLoading(true);
    // console.log('test')
    // return
    let product_options = "";
    let optionList = [...choosedOption];
    console.log(optionList);
    for (let i = 0; i < optionList.length; i++) {
      if (optionList[i].quantity != 0) {
        if (product_options.length == 0) {
          product_options +=
            optionList[i].id + "*green*" + optionList[i]["quantity"];
        } else {
          product_options +=
            "**green**" +
            optionList[i].id +
            "*green*" +
            optionList[i]["quantity"];
        }
      }
    }
    let weightsArr = [...weights];
    let weightstxt = "";
    for (let i = 0; i < weightsArr.length; i++) {
      if (weightsArr[i].product_count > 0) {
        if (weightstxt == "") {
          weightstxt +=
            weightsArr[i].weight +
            "*green*" +
            weightsArr[i].price +
            "*green*" +
            weightsArr[i].product_count;
        } else {
          weightstxt +=
            "**green**" +
            weightsArr[i].weight +
            "*green*" +
            weightsArr[i].price +
            "*green*" +
            weightsArr[i].product_count;
        }
      }
    }
    let optionList2 = [...choosedOption];
    let pushedOptions = [];
    setAddLoading(false);
    let product_options2 = "";
    for (let i = 0; i < optionList2.length; i++) {
      if (optionList2[i].quantity != 0) {
        pushedOptions.push(optionList2[i]);
        if (product_options.length == 0) {
          product_options2 +=
            optionList2[i].id + "*green*" + optionList2[i]["quantity"];
        } else {
          product_options2 +=
            "**green**" +
            optionList2[i].id +
            "*green*" +
            optionList2[i]["quantity"];
        }
      }
    }
    console.log(pushedOptions);
    if (item.productweights && item.productweights.length > 0) {
      let localCart = localStorage.getItem("local_cart");
      let CartData = localCart && JSON.parse(localCart);
      let pushedCart = [...CartData];

      for (let i = 0; i < weightsArr.length; i++) {
        if (weightsArr[i].product_count * 1 > 0) {
          let obj = {
            ...item,
            id: item.id,
            quantity: weightsArr[i].product_count,
            title_ar: item.title_ar,
            title_en: item.title_en,
            image: item.images[0] && item.images[0].url,
            weight: weightsArr[i].weight,
            discount: item.discount,
            price: weightsArr[i].price,
            price_for: item.price_for,
            product_options: product_options,
            has_option: product_options != "" ? 1 : 0,
            total_price:
              weightsArr[i].price * 1 * weightsArr[i].product_count * 1,
          };
          console.log(obj);
          // return
          // dispatch(addItem(obj))
          pushedCart.push(obj);
        }
      }
      dispatch(addWithWeight({ pushedCart: pushedCart }));
    } else {
      let pushedItem = {
        ...item,
        id: item.id,
        quantity: 1,
        title_ar: item.title_ar,
        title_en: item.title_en,
        image: item.images && item.images[0] && item.images[0].url,
        discount: item.discount,
        price: item.price,
        price_for: item.price_for,
        product_optionsarr: pushedOptions,
      };
      dispatch(addItem(pushedItem));
    }
    setWeightLoading(false);
    setAddLoading(false);
    setShowOpenWeight(false);
    getCartDetails();

    return;
    const data_send = {
      product_id: item.id,
      product_count: 1,
      has_option: 0,
      weights: weightstxt,
      has_weights: weights.length > 0 ? 1 : 0,
      // weight:weight.weight,
      // price:weight.price
      // product_options:
    };
    // console.log(data_send)
    // return ;
    Axios({
      url: BASE_URL + `cart/add_to_cart`,
      method: "post",
      data: data_send,
    })
      .then((res) => {
        if (res.status == "success") {
          toast.success(res.message);
          getItmData();
          dispatch(fetchCartData());
          getCartDetails();
        } else {
          toast.error(res.message);
        }
      })
      .finally(() => {
        setAddLoading(false);
        setWeightLoading(false);
      });
  };

  const editWeights = () => {
    setEditLoading(true);
    let weightsArr = [...weights];
    console.log(weights);
    let weightstxt = "";
    for (let i = 0; i < weightsArr.length; i++) {
      if (weightsArr[i].product_count > 0) {
        if (weightstxt == "") {
          weightstxt +=
            weightsArr[i].weight +
            "*green*" +
            (weightsArr[i].product_price || weightsArr[i].price) +
            "*green*" +
            weightsArr[i].product_count +
            "*green*" +
            weightsArr[i].cart_prod_id;
        } else {
          weightstxt +=
            "**green**" +
            weightsArr[i].weight +
            "*green*" +
            (weightsArr[i].product_price || weightsArr[i].price) +
            "*green*" +
            weightsArr[i].product_count +
            "*green*" +
            weightsArr[i].cart_prod_id;
        }
      }
    }
    let localCart = localStorage.getItem("local_cart");
    let cartData = localCart && JSON.parse(localCart);
    console.log(cartData);
    let FilteredCart = cartData.filter((it) => it.id != item.id);
    console.log(FilteredCart);
    let pushedCart = [...FilteredCart];
    for (let i = 0; i < weightsArr.length; i++) {
      // console.log(weightsArr[i])
      // return
      let newobj = {
        ...item,
        id: item.id,
        quantity: weightsArr[i].quantity,
        title_ar: item.title_ar,
        title_en: item.title_en,
        image: item.images && item.images[0] && item.images[0].url,
        weight: weightsArr[i].weight,
        discount: item.discount,
        price: weightsArr[i].price,
        price_for: item.price_for,
        total_price: weightsArr[i].price * 1 * weightsArr[i].quantity * 1,
      };
      if (weightsArr[i].quantity * 1 > 0) {
        // dispatch(addItem(newobj))
        // console.log(newobj);
        pushedCart.push(newobj);
      }
    }
    console.log(pushedCart);
    dispatch(addWithWeight({ pushedCart: pushedCart }));
    // localStorage.setItem('local_cart',JSON.stringify(pushedCart))
    // getData()
    toast.success(language == "ar" ? "تم التعديل" : "Success To Edit");
    // window.location.reload()
    setEditLoading(false);
    setShowChangeWeight(false);
    return;
    const data_send = {
      cart_id: item.cart_id,
      weights: weightstxt,
    };

    // return ;
    Axios({
      url: BASE_URL + `cart/edit_weights`,
      method: "POST",
      data: data_send,
    })
      .then((res) => {
        if (res.status == "success") {
          setWeights([]);
          dispatch(fetchCartData());
          setShowChangeWeight(false);
        } else {
          toast.error(language == "ar" ? "سجل الدخول أولا" : "Log in firsly");
        }
      })
      .finally(() => {
        setEditLoading(false);
      });
  };

  const handleDelWeight = (id) => {
    setWeights(
      weights.map((item) => {
        return { ...item, loading: true };
      })
    );
    Axios({
      url: BASE_URL + `cart/del_weight/${id}`,
      method: "GET",
    })
      .then((res) => {
        if (res.status == "success") {
          setWeights([]);
          dispatch(fetchCartData());
          // handleGetWeightsHere(item.cart_id);
          setShowChangeWeight(false);
        } else {
          toast.error(language == "ar" ? "سجل الدخول أولا" : "Log in firsly");
        }
      })
      .finally(() => {
        setWeights(
          weights.map((item) => {
            return { ...item, loading: true };
          })
        );
      });
  };
  const updateData = () => {};

  useEffect(() => {
    setTotalPrice(
      choosedOption && choosedOption?.length
        ? parseFloat(item?.price) +
            choosedOption?.reduce((a, b) => a + parseFloat(b?.totalPrice), 0)
        : parseFloat(item?.price)
    );
  }, [choosedOption]);
  const handleDelFromCart = (id) => {
    setDelLoading(true);
    const data_send = {
      product_id: id,
      product_count: 1,
      has_option: 0,
    };
    Axios({
      url: BASE_URL + "cart/add_to_cart",
      method: "POST",
      data: data_send,
    })
      .then((res) => {
        if (res.status == "success") {
          toast.success(res.message);
          getItmData();
          updateData();

          dispatch(fetchCartData());
          eqData();
          getCartDetails();
        } else {
          toast.error(language == "ar" ? "سجل الدخول أولا" : "Log in firsly");
        }
      })
      .finally(() => {
        setDelLoading(false);
        setAddLoading(false);
      });
  };

  const handleUpdate2 = () => {
    setWeightLoading(true);
    const data_send = {
    
      cart_id: item.cart_id,
      id: item.id,
      weight: weight.weight,
      price: weight.price,
    };
    Axios({
      url: BASE_URL + "cart/update_weight",
      method: "POST",
      data: data_send,
    })
      .then((res) => {
        if (res.status == "success") {
          getItmData();
          dispatch(fetchCartData());
        }
      })
      .finally(() => {
        setWeightLoading(false);
      });
  };
  return (
    <div className="ProductDetailsTexts">
      <div className="topText">
        <h5>{item.title && item?.title[language]}</h5>
        <p>{language == "ar" ? item.description_ar : item.description_en}</p>
      </div>
      <span>
        {item?.price}
        <span>{language == "ar" ? "درهم" : "AED"}</span>
      </span>
      {item.returnpolicies && item.returnpolicies?.length ? (
        <span className="return">
          {returnItem}
          <span
            onClick={() => {
              // console.log('eerer');
              setShowRetPop(true);
              setReturnpolicies(item.returnpolicies);
            }}
          >
            <>{language == "ar" ? "سياسة الإرجاع" : "Return Policy"}</>
          </span>
        </span>
      ) : null}
      {(offlineCart.items &&
        offlineCart.items.find((it) => it.id == item.id) == undefined) ||
      null ? (
        <div className="modalBtnAddToCart">
          {addLoading ? (
            <ThreeDots />
          ) : (
            <button
              className="btn btn-success"
              onClick={() => {
                console.log(item);
                // if(item.productweights.length==0&&item?.options.length==0) {
                //   addToCart()
                //   console.log('testtt2')
                // }
                if (
                  (offlineCart.items &&
                    offlineCart.items.find((it) => it.id == item.id) ==
                      undefined) ||
                  null
                ) {
                  if (
                    item.productweights.length &&
                    item.productweights.length > 0
                  ) {
                    setWeights(
                      item.productweights.map((item) => {
                        return { ...item, product_count: 0, checked: false };
                      })
                    );
                    if (item.options && item.options.length) {
                      addToCart();
                      console.log("e");
                    }
                    setShowOpenWeight(true);
                  }
                  if (
                    item?.options.length == 0 &&
                    item.productweights.length == 0
                  ) {
                    addToCart();
                    console.log("e");
                  }
                } else {
                  addToCart();
                  console.log(item);
                }
              }}
            >
              <> {language == "ar" ? "إضافة إلى العربة" : "Add To Cart"}</>
            </button>
          )}
        </div>
      ) : (
        <>
          {item.productweights && item.productweights.length > 0 ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaCartArrowDown
                onClick={() => {
                  navigate("/cart");
                }}
                style={{
                  color: "#009418",
                  cursor: "pointer",
                  fontSize: "30px",
                }}
              />
              <p
                style={{ margin: "0px" }}
                onClick={() => {
                  // setWeightsLoading(true);
                  console.log(item, "item");
                  setShowChangeWeight(true);
                  let pushedWeights = [];
                  let itemWeights = [...item?.productweights];
                  console.log(item);
                  console.log(itemWeights, "itemWeights");
                  let localCart = localStorage.getItem("local_cart");
                  let CartData = localCart && JSON.parse(localCart);
                  console.log(CartData);
                  for (let i = 0; i < itemWeights.length; i++) {
                    let obj = {
                      ...itemWeights[i],
                    };
                    let findInCart = CartData.find(
                      (it) =>
                        it.id == item.id && it.weight == itemWeights[i].weight
                    );
                    console.log(findInCart);
                    if (findInCart != undefined || findInCart != null) {
                      obj["product_count"] = findInCart.quantity;
                      obj["quantity"] = findInCart.quantity;
                      console.log("findInCart.quantity", findInCart.quantity);
                    } else {
                      obj["product_count"] = 0;
                      obj["quantity"] = 0;
                    }
                    pushedWeights.push(obj);
                  }
                  console.log(pushedWeights, "pushedWeightspushedWeights");
                  if (true) {
                    setWeights(pushedWeights);
                    // handleGetWeights(item.cart_id);
                  } else {
                    setWeights(pushedWeights);
                    console.log(
                      pushedWeights,
                      "pushedWeightspushedWeightspushedWeights"
                    );
                    // handleGetWeightsHere(item.cart_id);
                  }
                }}
                className="btn btn-primary"
              >
                <MdOutlineChangeCircle />
              </p>
            </div>
          ) : delLoading ? (
            <ThreeDots />
          ) : (
            <ProductInCartMangeButton
              inPrdDet={true}
              item={item}
              checkNotInProd={true}
              delCartItem={handleDelFromCart}
              updateCart={getItmData}
              itemIdToIncrement={item?.id}
              quantity={
                offlineCart.items &&
                offlineCart.items.length > 0 &&
                offlineCart.items.find((it) => it.id == item.id).quantity
              }
              update={update}
            />
          )}
        </>
      )}
      <PopUp
        open={showRetPop}
        setOpen={setShowRetPop}
        title={
          language == "ar" ? "سياسات إرجاع المنتج" : "Product Return Policies"
        }
      >
        {returnpolicies.map((item, index) => {
          return (
            <div className="retpoli">
              <p>{index + 1} - </p>
              <h5>{item.text}</h5>
            </div>
          );
        })}
      </PopUp>
      <PopUp
        open={showEditWeight}
        setOpen={setShowEditWeight}
        title={language == "ar" ? "تغيير الوزن" : "Change Weight"}
      >
        <div className="weights">
          {weights.map((weightItem, weightIndex) => {
            return (
              <div>
                <p>
                  {weightItem.price}
                  {language == "ar" ? "د.إ" : "AED"}
                </p>
                <div
                  onClick={() => {
                    setWeight(weightItem);
                    setWeights(
                      weights.map((item) => {
                        return {
                          ...item,
                          checked: item.id == weightItem.id ? true : false,
                        };
                      })
                    );
                  }}
                >
                  <div className="parent">
                    <div
                      onClick={() => {
                        setWeight(weightItem);
                        setWeights(
                          weights.map((item) => {
                            return {
                              ...item,
                              checked: item.id == weightItem.id ? true : false,
                            };
                          })
                        );
                      }}
                      className={
                        weightItem.checked ? "children active" : "children"
                      }
                    ></div>
                  </div>
                  <p>{weightItem.weight} KG</p>
                </div>
              </div>
            );
          })}
        </div>
        {weightLoading ? (
          <Spinner />
        ) : (
          <button
            className="btn btn-success"
            onClick={() => {
              handleUpdate2();
            }}
          >
            تحديث
          </button>
        )}
      </PopUp>
      <PopUp
        open={showOpenWeight}
        setOpen={setShowOpenWeight}
        title={language == "ar" ? "إضافة الوزن" : "Add Weight"}
      >
        <div className="weights">
          {weights.map((weightItem, weightIndex) => {
            return (
              <div className="weights">
                <p>
                  {weightItem.price}
                  {language == "ar" ? "د.إ" : "AED"}
                </p>
                <input
                  onChange={(e) => {
                    setWeights(
                      weights.map((it) => {
                        return {
                          ...it,
                          product_count:
                            it.id == weightItem.id
                              ? e.target.value
                              : it.product_count,
                          quantity:
                            it.id == weightItem.id
                              ? e.target.value
                              : it.product_count,
                          checked:
                            it.id && e.target.value == "" ? false : it.checked,
                        };
                      })
                    );
                  }}
                  className="input_change_count"
                  type="text"
                  placeholder={language == "ar" ? "الكميه" : "Count"}
                />
                <div
                  onClick={() => {
                    setWeight(weightItem);
                    // setWeights(weights.map((item)=>{
                    //   return {...item,checked:item.id==weightItem.id?true:false}
                    // }))
                  }}
                >
                  <div className="parent">
                    <div
                      onClick={() => {
                        setWeight(weightItem);
                        // setWeights(weights.map((item)=>{
                        //   return {...item,checked:item.id==weightItem.id?true:false}
                        // }))
                      }}
                      className={
                        weightItem.product_count > 0
                          ? "children active"
                          : "children"
                      }
                    ></div>
                  </div>
                  <p>{weightItem.weight} KG</p>
                </div>
              </div>
            );
          })}
        </div>
        {weightLoading ? (
          <Spinner />
        ) : (
          <button
            className="btn btn-success"
            onClick={() => {
              addToCart();
            }}
          >
            {language == "ar" ? "طلب" : "make order"}
          </button>
        )}
      </PopUp>
      <PopUp
        open={showChangeWeight}
        title={language == "ar" ? "الأوزان المتاحه" : "Weights"}
        setOpen={setShowChangeWeight}
        children={
          <>
            {" "}
            <div className="weights"></div>
            {false ? (
              <Skeleton count={3} />
            ) : weights && weights?.length ? (
              <div className="weights">
                <h4>{language == "ar" ? "الأوزان" : "Weights"}</h4>
                {weights.map((weightItem, weightIndex) => {
                  return (
                    <div className="price_wei_input_parent">
                      <p>
                        {weightItem.price}
                        {language == "ar" ? "د.إ" : "AED"}
                      </p>
                      <div className="change_count_div">
                        <span
                          onClick={() => {
                            let newWeights = [...weights];
                            console.log(newWeights);
                            setWeights(
                              newWeights.map((itWei) => {
                                return {
                                  ...itWei,
                                  product_count:
                                    itWei.id == weightItem.id
                                      ? itWei.product_count * 1 - 1
                                      : itWei.product_count,
                                  quantity:
                                    itWei.id == weightItem.id
                                      ? itWei.quantity * 1 - 1
                                      : itWei.quantity,
                                };
                                // return {...itWei,product_count:itWei.id==weightItem.id?itWei:}
                              })
                            );
                            // setWeights(weights.map((itemWei)=>{
                            //   return {...itemWei,product_count:itemWei.id==weightItem.id?weightItem.product_count*1-1:weightItem.product_count}
                            //   // return {...itemWei,product_count:itemWei.id==weightItem.id?itemWei.product_count*1-1:itemWei.product_count*1}
                            // }))
                          }}
                        >
                          -
                        </span>
                        <input
                          disabled={true}
                          value={weightItem.quantity}
                          onChange={(e) => {
                            setWeights(
                              weights.map((it) => {
                                return {
                                  ...it,
                                  product_count:
                                    it.id == weightItem.id
                                      ? e.target.value
                                      : it.product_count,
                                  checked:
                                    it.id == weightItem.id &&
                                    e.target.value == ""
                                      ? false
                                      : it.checked,
                                };
                              })
                            );
                          }}
                          className="count_price_weight_input"
                          type="text"
                          placeholder={language == "ar" ? "الكميه" : "Count"}
                        />
                        <span
                          onClick={() => {
                            let newWeights = [...weights];
                            console.log(newWeights);
                            setWeights(
                              newWeights.map((itWei) => {
                                return {
                                  ...itWei,
                                  product_count:
                                    itWei.id == weightItem.id
                                      ? itWei.product_count * 1 + 1
                                      : itWei.product_count,
                                  quantity:
                                    itWei.id == weightItem.id
                                      ? itWei.quantity * 1 + 1
                                      : itWei.quantity,
                                };
                                // return {...itWei,product_count:itWei.id==weightItem.id?itWei:}
                              })
                            );
                            // setWeights(weights.map((itemWei)=>{
                            //   return {...itemWei,product_count:itemWei.id==weightItem.id?weightItem.product_count*1+1:weightItem.product_count}
                            //   // return {...itemWei,product_count:itemWei.id==weightItem.id?itemWei.product_count*1+1:itemWei.product_count*1}
                            // }))
                          }}
                        >
                          +
                        </span>
                      </div>
                      {weightItem.in_cart == 1 ? (
                        weightItem.loading ? (
                          <Spinner />
                        ) : (
                          <IoMdClose
                            style={{
                              color: "red",
                              fontSize: "32px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleDelWeight(weightItem.cart_prod_id);
                            }}
                          />
                        )
                      ) : null}
                      <div
                      // onClick={() => {
                      //   setWeight(weightItem);
                      //   setTotalPrice(weightItem.price);
                      //   setWeights2(
                      //     weights2.map((item) => {
                      //       return {
                      //         ...item,
                      //         checked:
                      //           item.id == weightItem.id ? true : false,
                      //           product_count:0,
                      //       };
                      //     })
                      //   );
                      // }}
                      >
                        <div className="parent">
                          <div
                            // onClick={() => {
                            //   setWeight(weightItem);
                            //   // console.log(weightItem)
                            //   setTotalPrice(weightItem.price);
                            //   setWeights2(
                            //     weights2.map((item) => {
                            //       return {
                            //         ...item,
                            //         checked:
                            //           item.id == weightItem.id ? true : false,
                            //       };
                            //     })
                            //   );
                            // }}
                            className={
                              weightItem.product_count > 0
                                ? "children active"
                                : "children"
                            }
                          ></div>
                        </div>
                        <p>{weightItem.weight} KG</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
            <div>
              {editLoading ? (
                <Spinner />
              ) : (
                <button
                  onClick={() => {
                    editWeights();
                  }}
                  className="conf_btn"
                >
                  {language == "ar" ? "تعديل" : "Edit"}
                </button>
              )}
            </div>
          </>
        }
      />
    </div>
  );
};

export default ProductDetailsTexts;
